<template>
    <div>
        <div class="mini-card">
            <el-card>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <h2>{{ beaconShortID }}</h2>
                        <div class="info-identity">
                            <p><span>Beacon ID: </span><span class="data-display">{{ beacon.beaconID }}</span></p>
                            <p><span>Operator linked: </span><span class="data-display">{{ getOperatorName() }}</span></p>
                            <p><span>Operator group: </span><span class="data-display">{{ getOperatorGroup() }}</span></p>
                            <p><span>Beacon group: </span><span class="data-display">{{ beacon.group ? beacon.group : 'N/C' }}</span></p>
                        </div>
                        <el-row>
                            <el-tooltip class="item" effect="dark" :content="$t('edit')" placement="top">
                                <el-button v-if="isSuperAdmin" type="primary" icon="el-icon-edit" @click="editBeacon" circle></el-button>
                            </el-tooltip>
                            <el-tooltip class="item" effect="dark" :content="$t('duplicate')" placement="top">
                                <el-button v-if="isSuperAdmin" type="primary" icon="el-icon-document-copy" @click="duplicateBeacon" circle></el-button>
                            </el-tooltip>
                            <!-- <el-tooltip class="item" effect="dark" :content="$t('details')" placement="top">
                                <el-button type="primary" icon="el-icon-s-data" @click="getDetailsView" circle></el-button>
                            </el-tooltip> -->
                        </el-row>
                    </el-col>
                </el-row>
            </el-card>
        </div>
        <!-- start Modal for Create OF form -->
        <el-dialog
            width="1200px"
            :visible.sync="dialogFormVisible"
            :modalAppendToBody="false">
            <CreateBeacon :formStateModal="ofFormType" :beaconSelected="beacon" :key="dialogFormVisible" @closeForm="closeForm"></CreateBeacon>
        </el-dialog>
        <!-- end Modal for Create OF form -->
    </div>
</template>

<script>
import CreateBeacon from '../components/beacon/CreateBeacon.vue'
import DateTimeManipulation from '../mixins/DateTimeManipulation'

export default {
    components: {
        CreateBeacon
    },
    props: {
        beacon: {
            type: Object,
        }
    },
    data() {
        return {
            ofFormType: 'edit',
            dialogFormVisible: false,
            isSuperAdmin: false,
        }
    },
    created() {
         this.isSuperAdmin = this.$store.getters.isSuperAdmin;
    },
    computed: {
        beaconShortID: function() {
            return `${this.beacon.beaconShortID}`
        }
    },
    methods: {
        getOperatorName () {
            if(this.beacon.operator == undefined || this.beacon.operator.firstname == undefined) {
                return 'N/C'
            }
            return `${this.beacon.operator.firstname} ${this.beacon.operator.lastname}`
        },
        getOperatorGroup () {
            if(this.beacon.operator == undefined || this.beacon.operator.group == undefined) {
                return 'N/C'
            }
            return `${this.beacon.operator.group}`
        },
        editBeacon: function() {
            this.ofFormType = 'edit';
            this.dialogFormVisible = true;
        },
        duplicateBeacon: function() {
            this.ofFormType = 'duplicate';
            this.dialogFormVisible = true;
        },
        getDetailsView: function() {
            this.$router.push({ name: 'beacon-details', params: { id: this.beacon.beaconID } })
        },
        closeForm: function() {
            this.dialogFormVisible = false;
            this.$emit('closeForm', false);
        },
    },
    mixins: [DateTimeManipulation]
}
</script>

<style scoped>
    h3 {
        color: white;
    }

    .mini-card {
        margin-bottom: 20px;
    }

    .table-card {
        background-color: var(--color1light);
        padding: 10px;
        border-radius: 12px;
    }

    .info-identity {
        margin-bottom: 24px;

    }

    .info-identity > p {
        margin: 5px;
    }

    .data-display {
        font-weight: bold;
    }
</style>